'use client';
import { useGSAP } from '@gsap/react';
import { memo, useState } from 'react';
import { Box, Grid, Text, VStack } from '@chakra-ui/react';

import { startPositionAnimation } from 'shared/gsap';
import SliderControls from 'shared/SliderControls';
import { useSwiperControls } from 'shared/hooks';
import NextImage from 'shared/NextImage';
import InterText from 'shared/InterText';
import Slider from 'shared/Slider';

import { SECTIONS_IDS } from 'constants/global';
import { cardsData } from 'constants/startPosition';
import StartLine from 'assets/illustrations/startLine.svg';

const StartPosition = () => {
  const [swiper, setSwiper] = useState(null);
  const controls = useSwiperControls(swiper);

  useGSAP(startPositionAnimation);

  return (
    <Grid
      as="section"
      id={SECTIONS_IDS.startPosition}
      w="full"
      h={{ mobile: '550px', tablet: '570px', laptop: '815px' }}
      templateColumns="100%"
      templateRows="1fr"
      alignItems="center"
      justifyItems="center"
      color="ourWhite"
    >
      <Text
        as="h2"
        id={`${SECTIONS_IDS.startPosition}-title`}
        gridArea="1 / 1"
        w="full"
        px={{ mobile: '16px', tablet: '20px' }}
        textAlign="center"
        textTransform="uppercase"
        zIndex="1"
      >
        Твоя стартовая позиция
      </Text>

      <Text
        id={`${SECTIONS_IDS.startPosition}-subtitle`}
        gridArea="1 / 1"
        w="full"
        maxW={{ laptop: '1200px' }}
        px={{ mobile: '16px', tablet: '20px' }}
        textStyle="h5"
        textAlign="center"
        opacity="0"
        zIndex="2"
      >
        Траектория лидерства открывает путь в управленческую команду ASTON
      </Text>

      <Box
        id={`${SECTIONS_IDS.startPosition}-startLine`}
        gridArea="1 / 1"
        h={{ mobile: '80px', tablet: '110px', laptop: '160px' }}
        opacity="0"
        zIndex="3"
      >
        <NextImage src={StartLine} alt="Линия старта/финиша" w="full" h="full" />
      </Box>

      <VStack
        id={`${SECTIONS_IDS.startPosition}-cards`}
        gridArea="1 / 1"
        w="full"
        px={{ mobile: '16px', tablet: '80px' }}
        gap="40px"
        opacity="0"
        zIndex="4"
      >
        <SliderControls alignSelf="end" {...controls} />

        <Slider
          controller={swiper}
          setController={setSwiper}
          slidesData={cardsData}
          SlideComponent={StartPositionCard}
        />
      </VStack>
    </Grid>
  );
};

export default StartPosition;

const StartPositionCardComponent = ({ index, title, text }) => (
  <VStack
    w="full"
    maxW={{ tablet: '470px', laptop: '540px' }}
    minH={{ mobile: '280px', tablet: '320px', laptop: '430px' }}
    align="start"
    bg="ourWhite"
    borderRadius={{ mobile: '24px', tablet: '32px', laptop: '48px' }}
    p={{ mobile: '24px', tablet: '32px', laptop: '40px' }}
    justify="space-between"
    color="greenMuted"
  >
    <Text textStyle="h4">{index}</Text>

    <VStack w="full" align="start" gap={{ mobile: '10px', tablet: '24px' }}>
      <Text as="h3" textStyle="h2" fontSize={{ laptop: '48px' }}>
        {title}
      </Text>

      <InterText textStyle="b3" color="ourGrayThree">
        {text}
      </InterText>
    </VStack>
  </VStack>
);

const StartPositionCard = memo(StartPositionCardComponent);
